var _path, _path2, _path3, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCppIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ISO_C__Logo",
    "data-name": "ISO_C++_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.436,
    height: 32,
    viewBox: "0 0 28.436 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M166.856,102.088a2.52,2.52,0,0,0,.362-1.213V87.3a2.519,2.519,0,0,0-.362-1.213l-13.856,8Z",
    transform: "translate(-138.782 -78.088)",
    fill: "#00599c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M18.981,187.882l11.756-6.787a2.519,2.519,0,0,0,.87-.92l-13.856-8-13.856,8a2.519,2.519,0,0,0,.87.92l11.756,6.787A2.731,2.731,0,0,0,18.981,187.882Z",
    transform: "translate(-3.531 -156.175)",
    fill: "#004482"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M28.075,8a2.521,2.521,0,0,0-.87-.92L15.449.293a2.731,2.731,0,0,0-2.463,0L1.231,7.08A2.732,2.732,0,0,0,0,9.213V22.787A2.519,2.519,0,0,0,.362,24l13.856-8Z",
    fill: "#659ad2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(4.739 6.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M60.479,89.132a9.479,9.479,0,1,1,8.209-14.221l-4.1,2.374a4.739,4.739,0,1,0,0,4.737l4.1,2.374A9.513,9.513,0,0,1,60.479,89.132Z",
    transform: "translate(-51 -70.175)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(20.537 14.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M224.16,156.228h-1.053v-1.053h-1.053v1.053H221v1.053h1.053v1.053h1.053v-1.053h1.053Z",
    transform: "translate(-221 -155.175)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(24.487 14.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M266.66,156.228h-1.053v-1.053h-1.053v1.053H263.5v1.053h1.053v1.053h1.053v-1.053h1.053Z",
    transform: "translate(-263.5 -155.175)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCppIcon);
export default __webpack_public_path__ + "static/media/CppIcon.4f48024067493e2d6f75f7e0e8d3430a.svg";
export { ForwardRef as ReactComponent };